module.exports = __webpack_public_path__ + "static/rozpuszczalne_stick_karton-16a7254beada4a8c1ab121006fc95fc5.png";